// SPDX-FileCopyrightText: © 2023 Schneider Electric
//
// SPDX-License-Identifier: Apache-2.0

import type { ComponentInterface } from "@stencil/core";
import { Component, Element, h, Host, Prop, State } from "@stencil/core";

import { onMobileBreakpoint, randomId } from "../utils";

@Component({
  tag: "qds-web-megamenu-list",
  shadow: true,
  styleUrl: "megamenu-list.css",
})
export class MegamenuList implements ComponentInterface {
  @Element() public element: HTMLElement;

  /**
   * Determines the minimum width in pixels of the children of the carousel.
   *
   * @remarks
   * This property specifies the minimum width that each child item within the carousel component should have. Increasing this value will result in wider child items.
   *
   * @public
   * @type {number}
   * @default 300
   */
  @Prop() public itemMinWidth = 275;

  @State() public megamenuListRef: string;

  @State() public isMobile: boolean;

  private cleanupMobileListener?: () => void;

  public componentWillLoad(): Promise<void> | void {
    this.cleanupMobileListener = onMobileBreakpoint((isMobile: boolean) => {
      this.isMobile = isMobile;
    }, this.element);
    this.megamenuListRef = this.element.id || randomId();
  }

  public disconnectedCallback(): void {
    this.cleanupMobileListener?.();
  }

  public render() {
    return (
      <Host>
        {this.isMobile ? (
          <slot />
        ) : (
          <qds-web-carousel
            aria-label="Megamenu"
            item-min-width={this.itemMinWidth}
            id={`carousel-${this.megamenuListRef}`}
          >
            <slot />
          </qds-web-carousel>
        )}
      </Host>
    );
  }
}
